<!--
  详情页 - 采购退货产品信息
  props:
    id: 详情id
 -->

<template>
	<div class="v-tabs product-list">
    <div class="head">
      <div class="total">
        {{tableData.length}}种产品{{totalProducts}}件
      </div>
      <div class="inline-item">
        退货总计：<span class="red">{{others.totalProdcutMoney}}</span>元
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="55">
        </el-table-column>
        <el-table-column
          label="产品名称"
          width="190"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.productName || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="productNo"
          label="产品编号"
          width="90"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="产品条码"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.barcode || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="规格"
          width="90"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.specification || '--'}}
          </template>
        </el-table-column>
        <el-table-column
          property="num"
          label="数量"
          width="70"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="备注"
          width="80"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.memo || '--'}}
          </template>
        </el-table-column>
        <el-table-column
          label="单位"
          width="60"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{scope.row.unit || '--'}}
          </template>
        </el-table-column>
<!--         <el-table-column
          property="price"
          label="单价 (元)"
          width="80"
          show-overflow-tooltip>
        </el-table-column> -->
        <el-table-column
          property="productPrice"
          label="采购价 (元)"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>
	</div>
</template>

<script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      explains: [],
      tableData: [],
      others: ''
    }
  },
  computed: {
    totalProducts () {
      let i = 0
      this.tableData.forEach(item => {
        // i += item.num
        i = utils.plus(i, item.num)
      })
      return i
    }
  },
  methods: {
    getList () {
      let url = '/returnedPurchase/returnedPurchaseProductList.html'
      let params = {
        returnedPurchaseId: this.id
      }
      api.post(url, params, (data) => {
        this.tableData = data.productList
        this.others = data.others
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// product-list.vue?1a2fb5fe